<div class="overlay-connection">
  <dss-content-loader [show]="true" [path]="'assets/page-loader/default.json'"></dss-content-loader>
  <div class="dss-display-flex dss-flex-column dss-align-items-center dss-justify-content-center">
    <span class="title">{{ "CONNECTION.TITLE" | translate }}</span>
    <span class="subtitle">{{ "CONNECTION.SUBTITLE" | translate }}</span>
  </div>
</div>